import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getMyWorksToControl(companyId, query) {
  return dataTransferWrap(
    ModulesMap.DONE_WORKS_MY_WORKS_TO_CONTROL,
    dtConfig[ModulesMap.DONE_WORKS_MY_WORKS_TO_CONTROL].getMyWorksToControl,
    {
      urlParams: {
        companyId,
      },
      params: query,
    },
  )
}

export default {
  getMyWorksToControl,
}